"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface SpotlightProps {
  className?: string;
  /** Center color of the glow. */
  fill?: string;
  /** Diameter in viewport-height units (vh). */
  size?: number;
}

/**
 * A soft, blurred radial glow blob — drop behind a section for the cosmic
 * "lit from within" look. Purely decorative (aria-hidden), fades in once,
 * and breathes subtly (disabled under reduced motion via Framer).
 */
export function Spotlight({ className, fill = "rgba(168,85,247,0.22)", size = 60 }: SpotlightProps) {
  return (
    <motion.div
      aria-hidden
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 1.4, ease: "easeOut" }}
      className={cn(
        "pointer-events-none absolute -z-10 rounded-full blur-[120px] motion-safe:animate-float",
        className,
      )}
      style={{
        width: `${size}vh`,
        height: `${size}vh`,
        background: `radial-gradient(circle at center, ${fill}, transparent 70%)`,
      }}
    />
  );
}
